import { render, staticRenderFns } from "./CardChoose.vue?vue&type=template&id=6c7124c3&scoped=true&"
import script from "./CardChoose.vue?vue&type=script&lang=js&"
export * from "./CardChoose.vue?vue&type=script&lang=js&"
import style0 from "./CardChoose.vue?vue&type=style&index=0&id=6c7124c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7124c3",
  null
  
)

export default component.exports